/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_Stat_ApprovalInputs */

const tr_landing_cockpit_stat_approval = /** @type {(inputs: Landing_Cockpit_Stat_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ort. onay süresi`)
};

const en_landing_cockpit_stat_approval = /** @type {(inputs: Landing_Cockpit_Stat_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`avg. approval time`)
};

const de_landing_cockpit_stat_approval = /** @type {(inputs: Landing_Cockpit_Stat_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ø Freigabezeit`)
};

const ru_landing_cockpit_stat_approval = /** @type {(inputs: Landing_Cockpit_Stat_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ср. время одобрения`)
};

/**
* | output |
* | --- |
* | "avg. approval time" |
*
* @param {Landing_Cockpit_Stat_ApprovalInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_stat_approval = /** @type {((inputs?: Landing_Cockpit_Stat_ApprovalInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Stat_ApprovalInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_stat_approval(inputs)
	if (locale === "de") return de_landing_cockpit_stat_approval(inputs)
	if (locale === "ru") return ru_landing_cockpit_stat_approval(inputs)
	return tr_landing_cockpit_stat_approval(inputs)
});